import gql from 'graphql-tag';

export const healthCheck = gql`
  {
    healthCheck
  }
`;
